<template>
  <!-- <f7-page class=""> -->
  <div class="page">
    <!--bottom-toolbar></bottom-toolbar-->
    <div class="page-content">
      <!-- <page-nav-bar class="" currentServiceName="MoneyRoad" subNavTitle="Create Remind" :closePage="true"></page-nav-bar> -->
      <div class="layoutTop"/>
      <div class="container-fluid">

        <div class="row">
          <div class="col-md-12">
            <div class="panel21 panel-default">
              <form>
                <div class="form-group row">
                  <label class="col-5 col-sm-2 col-form-label">Label</label>
                  <div class="col-7 col-sm-10">
                    <input class="form-control" name="label" type="text" placeholder="Label" v-model="label"></input>
                  </div>
                </div>
                <div class="form-group row">
                  <a href="/settings/remind/contactList/add/" class="item-link item-content">
                    <div class="item-inner col-form-label col-sm-12">
                      <div class="item-title">Contact and contact group</div>
                    </div>
                  </a>
                </div>
                <div class="form-group row">
                  <label id="add-reminder-frequence-picker" class="col-5 col-sm-2 col-form-label">Frequence</label>
                  <div class="col-7 col-sm-10">
                    <input class="form-control" type="text" placeholder="Choose frequence" readonly @click="openFrequencePicker" v-model="frequenceLabel"></input>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-2 col-form-label">Remind method : </label>
                  <div class="col-sm-10">
                    <label class="label-checkbox item-content form-check-inline">
                      <input type="checkbox" class="checkboxApplicationMode" @change="changeApplicationMode" v-bind:value="applicationMode">
                      <div class="item-media">
                        <i class="icon icon-form-checkbox"></i>
                      </div>
                      <div class="item-inner">
                        <div class="item-title"> MoneyRoad</div>
                      </div>
                    </label>
                    <label class="label-checkbox item-content form-check-inline">
                      <input type="checkbox" class="checkboxEmailMode" @change="changeEmailMode" v-bind:value="emailMode">
                      <div class="item-media">
                        <i class="icon icon-form-checkbox"></i>
                      </div>
                      <div class="item-inner">
                        <div class="item-title"> Email</div>
                      </div>
                    </label>
                    <label class="label-checkbox item-content form-check-inline">
                      <input type="checkbox" class="checkboxSmsMode" @change="changeSmsMode" v-bind:value="smsMode">
                      <div class="item-media">
                        <i class="icon icon-form-checkbox"></i>
                      </div>
                      <div class="item-inner">
                        <div class="item-title"> SMS</div>
                      </div>
                    </label>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-9"/>
          <div class="col-md-3">
            <button round class="button-action firstButtonMarginTop" @click="createRemindSetting">
              <i class="icon fa fa-save"></i>
              <span>Save</span>
            </button>
            <div class="toolbarPageBottomBlank"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
  <!-- </f7-page> -->
</template>

<script>
import {errorMessageAlert} from '@/helpers/alert'
import pageNavBar from '@/components/common/pageNavBar.vue'
import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'
import {loadPage} from '@/helpers/routing'

export default {
  components: {
    'page-nav-bar': pageNavBar,
    'bottom-toolbar': bottomToolbar
  },
  data: () => {
    return {
      label: '',
      contactsSelected: [],
      contactGroupsSelected: [],
      frequencePicker: '',
      frequenceLabel: '',
      frequenceUnit: '',
      frequenceNumber: '',
      applicationMode: false,
      emailMode: false,
      smsMode: false
    }
  },
  created () {
    let that = this
    that.label = ''
    that.frequencePicker = ''
    that.frequenceLabel = ''
    that.frequenceUnit = ''
    that.frequenceNumber = ''
    that.applicationMode = false
    that.emailMode = false
    that.smsMode = false
    that.contactsSelected = []
    that.contactGroupsSelected = []
    this.$engine.settings.remindSettings.addRemindSettingContactsSelected = []
    this.$engine.settings.remindSettings.addRemindSettingContactGroupsSelected = []
    var frequenceOptions = {
      days: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30'],
      months: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
      years: ['1', '2', '3', '4', '5']
    }
    this.frequencePicker = this.$f7.picker({
      input: '#add-reminder-frequence-picker',
      rotateEffect: true,
      formatValue: function (picker, values) {
        return values[1]
      },
      cols: [
        {
          values: ['Every'],
          width: 100
        },
        {
          values: frequenceOptions.days,
          width: 60
        },
        {
          textAlign: 'left',
          values: ['days', 'months', 'years'],
          width: 100,
          onChange: function (picker, unit) {
            if (picker.cols[1].replaceValues) {
              picker.cols[1].replaceValues(frequenceOptions[unit])
            }
          }
        }
      ],
      onChange: function (p) {
        let result = ''
        for (let i = 0; i < p.value.length; i++) {
          result += ' '
          result += p.value[i]
        }
        that.frequenceLabel = result
        that.frequenceNumber = p.value[1]
        that.frequenceUnit = p.value[2]
        // that.creditorBank = ibansMapObj[p.value]
        // that.creditorBankName = p.value
      }
    })
    that.$bus.$on('refresh-add-remind-setting-contacts', (contactsFromList, contactGroupsFromList) => {
      that.contactsSelected = contactsFromList
      that.contactGroupsSelected = contactGroupsFromList
    })
  },
  methods: {
    changeApplicationMode (obj) {
      this.applicationMode = obj.target.checked
    },
    changeEmailMode (obj) {
      this.emailMode = obj.target.checked
    },
    changeSmsMode (obj) {
      this.smsMode = obj.target.checked
    },
    openFrequencePicker (e) {
      e.stopPropagation()
      this.frequencePicker.open()
    },
    createRemindSetting () {
      let that = this
      if (this.label === '') {
        this.$f7.alert('', 'Label missing')
        return
      } else if (this.contactsSelected.length === 0 && this.contactGroupsSelected.length === 0) {
        this.$f7.alert('', 'Contact missing')
        return
      } else if (this.frequenceNumber === '' && this.frequenceUnit === '') {
        this.$f7.alert('', 'Frequence missing')
        return
      } else if (this.applicationMode === false && this.emailMode === false && this.smsMode === false) {
        this.$f7.alert('', 'Remind type missing')
        return
      }

      let multiplicand = parseInt(that.frequenceNumber)
      let multiplier = 0
      if (that.frequenceUnit === 'days') {
        multiplier = 1
      } else if (that.frequenceUnit === 'months') {
        multiplier = 30
      } else if (that.frequenceUnit === 'years') {
        multiplier = 365
      } else {
        multiplier = 1
      }
      let frequence = multiplicand * multiplier
      let requestLoad = {
        'idAccount': that.$engine.user.get().id,
        'label': that.label,
        'frequence': frequence,
        'emailType': that.emailMode === true ? '1' : '0',
        'applicationType': that.applicationMode === true ? '1' : '0',
        'smsType': that.smsMode === true ? '1' : '0',
        'contacts': that.contactsSelected,
        'contactGroups': that.contactGroupsSelected
      }
      that.$engine.settings.remindSettings.create(requestLoad)
      .then(() => {
        that.$bus.$emit('refresh-cache-remind-settings')
        that.$f7.hidePreloader()
        // that.$bus.$emit('refresh-cache-contacts')
        this.$f7.modal({
          title: 'Reminder added',
          text: '<span class="preloader"></span>'
        })
        setTimeout(function () {
          that.$f7.closeModal()
          // that.$$(document).off('taphold', '.testTap')
          loadPage(that, {url: '/settings/remind/', force: false, ignoreCache: false})
        }, 2000)
      })
      .catch(err => {
        that.$f7.hidePreloader()
        errorMessageAlert(err, this)
      })
    }
  }
}
</script>
<style>
.container {
    /* margin-right: auto;
    margin-left: auto; */
    width: 100%;
    /* margin: 0 auto; */
}
.panel2, .panel21 {
    background: #fcfcfc;
    border: solid 1px #dbdbdb;
    /*margin-bottom: 5%;*/
    padding-bottom: 25px;
    padding-top: 10px;
    padding-left: 20px;
    padding-right: 20px;
    float: left;
    width: 100%;
}
* {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
}
a:hover {
    text-decoration: none;
}
/*
.col-md-offset-3 {
    margin-left: 25%;
    margin-top: 2%;

}
*/
 .col-md-12 {
    float: right;
    width: 100%;
}
.col-md-4 {
  /*float: left;*/
  width: 100%;
  margin: 0px;
}

.label-switch {
  float: right;
}

.no-bullets {
    list-style-type: none;
}
.mt-2 {
  width: 100%;
}
.inputFileButton {
  float: left;
}
.list-block {
    padding: 0px 0px 0px 0px;
    margin: auto;
    width: 100%
}

.button-setting {
  width: 80px;
}
</style>



// WEBPACK FOOTER //
// CMAddRemindSetting.vue?60cc3320